import { X, Check } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";

const before = [
  "Réservations dispersées entre WhatsApp, téléphone et cahier",
  "Planning difficile à suivre au quotidien",
  "Paiements mal suivis",
  "Dépenses perdues dans les notes",
  "Flotte gérée à part, sans vision d'ensemble",
  "Aucune vision claire du résultat",
];

const after = [
  "Toutes vos réservations centralisées",
  "Un planning clair, par jour ou par semaine",
  "Caisse et encaissements suivis en temps réel",
  "Dépenses et justificatifs au même endroit",
  "Flotte, maintenance et incidents reliés à l'activité",
  "Votre résultat estimé visible en un coup d'œil",
];

const Problem = () => (
  <section data-testid="problem-section" className="py-16 sm:py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-3xl">
        <Eyebrow index="01">Le problème</Eyebrow>
        <h2 className="mt-4 text-balance text-3xl font-bold tracking-tight text-navy sm:text-4xl">
          Votre activité mérite mieux que WhatsApp + Excel.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-navy/60 sm:text-lg">
          La plupart des exploitants pilotent encore leur entreprise entre messagerie, cahiers, tableurs et appels.
          Résultat : des erreurs, du temps perdu et aucune vision claire.
        </p>
      </Reveal>

      <div className="mt-14 grid gap-6 lg:grid-cols-2">
        <Reveal delay={0.1}>
          <div className="h-full rounded-3xl border border-slate-200 bg-white p-8 shadow-soft">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-red-500">Avant</p>
            <h3 className="mt-2 text-xl font-semibold text-navy">L'exploitation dispersée</h3>
            <ul className="mt-6 space-y-4">
              {before.map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm text-navy/65">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-50 text-red-500">
                    <X className="h-3 w-3" />
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="relative h-full overflow-hidden rounded-3xl border border-brand/15 bg-navy p-8 shadow-lift">
            <div className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full bg-brand/20 blur-3xl" aria-hidden="true" />
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-turquoise">Avec ActiPilote</p>
            <h3 className="mt-2 text-xl font-semibold text-white">Tout est au même endroit</h3>
            <ul className="mt-6 space-y-4">
              {after.map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm text-white/80">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-turquoise/15 text-turquoise">
                    <Check className="h-3 w-3" />
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Problem;
